module.exports = __webpack_public_path__ + "static/media/general-commonAreasCharm.77162ab8.png";